<tt-page *ngIf="!!info && !!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-input ttLabel="custactcalcedit_note" [ttModel]="info.note" ttReadonly></tt-input>

            <tt-tabs [ttRememberId]="'w_custactcalcpick.bg_custactcalc_view' + '/' + params?.p2_pofinish_keyno + '/' + params?.custact_no" [(ttSelectedId)]="setting.bg_custactcalc_view" (ttSelectedIdChange)="onTabChanged()">
                <tt-tab ttId="INFO" ttLabel="bg_custactcalc_view_info"></tt-tab>
                <tt-tab ttId="PICK" ttLabel="bg_custactcalc_view_pick"></tt-tab>
                <tt-tab ttId="PICKED" ttLabel="bg_custactcalc_view_picked"></tt-tab>
            </tt-tabs>

            <div [hidden]="setting.bg_custactcalc_view !== 'INFO'">
                <ng-container *ngTemplateOutlet="infoFields"></ng-container>
            </div>

            <tt-select [hidden]="setting.bg_custactcalc_view !== 'PICK'" ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>

            <div [hidden]="setting.bg_custactcalc_view !== 'PICK' && setting.bg_custactcalc_view !== 'PICKED'">
                <tt-input [ttRememberId]="'w_custactcalcpick.filtervalue' + '/' + params?.p2_pofinish_keyno + '/' + params?.custact_no" ttLabel="custactcalcpick_filter" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
                <tt-button ttText="custactcalcpick_new_comp" (ttClick)="goToFunc('productsearch')" ttIcon="far fa-plus"></tt-button>
            </div>
        </tt-card>

        <tt-list-legacy [hidden]="setting.bg_custactcalc_view !== 'PICK' && setting.bg_custactcalc_view !== 'PICKED'" [listItems]="itemsListComponents" ltype="multi" typevar="g" [filterVal]="setting.filtervalue"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="custactcalcpick_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card class="col-xs-12 p-5">
                        <tt-input ttLabel="custactcalcedit_note" [ttModel]="info.note" ttReadonly></tt-input>
                        <ng-container *ngTemplateOutlet="infoFields"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-card class="col-xs-12 p-5">
                        <tt-tabs [ttRememberId]="'w_custactcalcpick.bg_custactcalc_view' + '/' + params?.p2_pofinish_keyno + '/' + params?.custact_no" [(ttSelectedId)]="setting.bg_custactcalc_view" (ttSelectedIdChange)="onTabChanged()">
                            <tt-tab ttId="PICK" ttLabel="bg_custactcalc_view_pick"></tt-tab>
                            <tt-tab ttId="PICKED" ttLabel="bg_custactcalc_view_picked"></tt-tab>
                        </tt-tabs>
                    </tt-card>

                    <div class="col-xs-12 sp-0">
                        <tt-card class="col-xs-12 col-md-6 p-5">
                            <tt-input [ttRememberId]="'w_custactcalcpick.filtervalue' + '/' + params?.p2_pofinish_keyno + '/' + params?.custact_no" ttLabel="custactcalcpick_filter" ttFocus="false" [(ttModel)]="setting.filtervalue" ttShowClearButton></tt-input>
                        </tt-card>

                        <tt-card class="col-xs-12 col-md-6 p-5" [hidden]="setting.bg_custactcalc_view !== 'PICK'">
                            <tt-select ttLabel="stockplace" [(ttModel)]="setting.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
                        </tt-card>
                    </div>

                    <tt-card class="col-xs-12 p-5">
                        <tt-button ttText="custactcalcpick_new_comp" (ttClick)="goToFunc('productsearch')" ttIcon="far fa-plus"></tt-button>
                    </tt-card>

                    <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListComponents" ltype="multi" typevar="g" [filterVal]="setting.filtervalue"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #infoFields>
    <ng-container *ngIf="!!info">
        <tt-textarea ttLabel="text_sales" [ttModel]="info.text_sales" ttReadonly></tt-textarea>
        <tt-textarea ttLabel="text_production" [ttModel]="info.text_production" ttReadonly></tt-textarea>
        <tt-input ttLabel="drawing_no" [ttModel]="info.drawing_no" ttReadonly></tt-input>
        <tt-button-goto [ttText]="'documents'" [ttBadge]="info.nbr_of_documents" [ttGoto]="'documents'" [ttGotoParms]="{ argtype: 'custact_no', argvalue: info.custact_no }"></tt-button-goto>
        <tt-button-goto [ttText]="'pictures'" [ttBadge]="info.nbr_of_pictures" [ttGoto]="'pictures'" [ttGotoParms]="{ argtype: 'custact_no', argvalue: info.custact_no }"></tt-button-goto>
    </ng-container>
</ng-template>
